import { render, staticRenderFns } from "./UnverifiedOrganization.vue?vue&type=template&id=68e25f52&"
import script from "./UnverifiedOrganization.vue?vue&type=script&lang=ts&"
export * from "./UnverifiedOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports